import { Upload } from '@formily/antd';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'Upload',
    component: Upload.Dragger,
});
